export type LedgerTopic = "Payroll" | "HR Technology" | "Implementation" | "Process";
export type LedgerFormat = "Essay" | "Field Note" | "Analysis" | "Operator Perspective" | "Guide";

export type LedgerArticle = {
  id: string;
  title: string;
  dek: string;
  topic: LedgerTopic;
  format: LedgerFormat;
  date: string;
  readTime: string;
  featured?: boolean;
};

export const ledgerTopics: LedgerTopic[] = ["Payroll", "HR Technology", "Implementation", "Process"];
export const ledgerFormats: LedgerFormat[] = ["Essay", "Field Note", "Analysis", "Operator Perspective", "Guide"];

export const ledgerArticles: LedgerArticle[] = [
  {
    id: "went-live",
    title: "Your HRIS went live. That doesn’t mean it’s right.",
    dek: "Go-live proves the system turns on. It says very little about whether it’s configured the way you pay people.",
    topic: "HR Technology",
    format: "Essay",
    date: "Sep 2026",
    readTime: "8 min",
    featured: true,
  },
  {
    id: "first-72-hours",
    title: "The first 72 hours after your payroll lead resigns",
    dek: "What to secure, in what order, before the next pay date arrives.",
    topic: "Payroll",
    format: "Field Note",
    date: "Sep 2026",
    readTime: "6 min",
  },
  {
    id: "parallel-payroll",
    title: "Parallel payroll is not a formality",
    dek: "The most skipped step of an implementation is the one that catches the expensive mistakes.",
    topic: "Implementation",
    format: "Guide",
    date: "Aug 2026",
    readTime: "8 min",
  },
  {
    id: "configuration-review",
    title: "The configuration review nobody schedules",
    dek: "Most payroll errors aren’t processing errors. They were set up that way.",
    topic: "HR Technology",
    format: "Analysis",
    date: "Aug 2026",
    readTime: "7 min",
  },
  {
    id: "integrations-fail-quietly",
    title: "Integrations fail quietly",
    dek: "Most HRIS-to-payroll errors don’t throw an alert. They just send the wrong number.",
    topic: "HR Technology",
    format: "Field Note",
    date: "Jul 2026",
    readTime: "6 min",
  },
  {
    id: "payroll-calendars",
    title: "A payroll calendar is a control, not a convenience",
    dek: "The cheapest check a payroll team will ever own.",
    topic: "Process",
    format: "Guide",
    date: "Jul 2026",
    readTime: "5 min",
  },
  {
    id: "after-go-live",
    title: "Why implementations fail after go-live",
    dek: "The project ends. The work begins. Most failures live in the gap between them.",
    topic: "Implementation",
    format: "Essay",
    date: "Jun 2026",
    readTime: "10 min",
  },
  {
    id: "provider-cant-fix",
    title: "What your payroll provider can’t fix for you",
    dek: "Providers run the engine. They don’t own your pay rules, your data, or your decisions.",
    topic: "Payroll",
    format: "Operator Perspective",
    date: "May 2026",
    readTime: "7 min",
  },
  {
    id: "team-hates-system",
    title: "Your team hates the system. That’s usually a configuration problem.",
    dek: "Before replacing a platform, look at how it was set up.",
    topic: "HR Technology",
    format: "Operator Perspective",
    date: "May 2026",
    readTime: "6 min",
  },
  {
    id: "multi-entity",
    title: "Multi-entity payroll and the cost of informal ownership",
    dek: "When every entity is someone’s side job, no entity is anyone’s.",
    topic: "Payroll",
    format: "Analysis",
    date: "Apr 2026",
    readTime: "9 min",
  },
  {
    id: "sop-nobody-writes",
    title: "Writing the payroll SOP nobody wants to write",
    dek: "A practical template, and the order to write it in.",
    topic: "Process",
    format: "Guide",
    date: "Mar 2026",
    readTime: "7 min",
  },
  {
    id: "vendor-escalation",
    title: "Vendor escalation, done properly",
    dek: "How to get a payroll or HRIS vendor to act — with evidence, not volume.",
    topic: "Payroll",
    format: "Field Note",
    date: "Feb 2026",
    readTime: "6 min",
  },
];
